import type { Media } from "@/models"
import { axios } from "@/axios"

export async function moveToAlbum(eventVaultId?: number, media: Media[] = [], albumId?: number) {
  if (!eventVaultId) {
    throw new Error("Missing `eventVaultId` when attempting to move media. Please ensure `eventVaultId` is provided.")
  }

  const picIds = media.filter(m => m.type === "pic").map(m => m.id)
  const vidIds = media.filter(m => m.type === "vid").map(m => m.id)

  const response = await axios.post(`api/event/${eventVaultId}/album/move`, {
    toEventAlbumId: albumId && albumId > 0 ? albumId : undefined,
    resources: {
      photos: picIds,
      videos: vidIds,
    },
  })

  return response.data?.Data
}
